const state = {
	alignment: "",
	name: "",
	deity: "",
	gender: "",
	homeworld: "",
	image: "",
	languages: [],
	long_description: "",
	player: "",
	short_description: "",
	speed: "",
	theme: "",
}

const getters = {
	get: (state) => (property) => {
		return state[property]
	},
	alignment (state) {
		return state.alignment
	},
	name (state) {
		return state.name
	},
	deity (state) {
		return state.deity
	},
	gender (state) {
		return state.gender
	},
	homeworld (state) {
		return state.homeworld
	},
	image (state) {
		return state.image
	},
	languages (state) {
		return state.languages
	},
	long_description (state) {
		return state.long_description
	},
	player (state) {
		return state.player
	},
	short_description (state) {
		return state.short_description
	},
	speed (state) {
		return state.speed
	},
	theme (state) {
		return state.theme
	},
}

const mutations = {
	set (state, payload){
		state[payload.property] = payload.value
	},
	setBio (state, items) {
		for(const item in items){
			state[item] = items[item]
		}
	}
}

const actions = {
	loadCharacter ({ commit }, character) {
		commit('setBio', {
			alignment: character.Bio.Alignment,
			name: character.Bio['Character Name'],
			deity: character.Bio.Deity,
			gender: character.Bio.Gender,
			homeworld: character.Bio.Homeworld,
			image: character.Bio.Image,
			languages: character.Bio.Languages.split(/[ ,]+/),
			long_description: character.Bio.LongDescription,
			player: character.Bio.Player,
			short_description: character.Bio.ShortDescription,
			speed: character.Bio.Speed,
			theme: character.Bio.Theme,
		})
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}